import { render, staticRenderFns } from "./BlockScreen.vue?vue&type=template&id=5f52fca6&scoped=true"
import script from "./BlockScreen.vue?vue&type=script&lang=js"
export * from "./BlockScreen.vue?vue&type=script&lang=js"
import style0 from "./BlockScreen.vue?vue&type=style&index=0&id=5f52fca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52fca6",
  null
  
)

export default component.exports